import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { SideNav } from "components";
import { MainBody, OverlayLoader, PageTitle } from "components/core";
import { WidthLimiter } from "./styles";
import GpaGtlForm from "components/PlanSetup/GpaGtlForm";
import http from "services/httpService";

const GpaGtlSetup = () => {
  const { state } = useLocation();
  const [setupDetails, setSetupDetails] = useState();
  const [isLoading, setIsLoading] = useState(true);

  // fetch GPA/GTL setup details
  const fetchSetupDetails = async (type) => {
    try {
      setIsLoading(true);
      const url =
        type === "GPA"
          ? "/business/get_gpa_plan_setup_details/"
          : "/business/get_gtl_plan_setup_details/";
      const { data } = await http.get(url);
      setSetupDetails(data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async function () {
      await fetchSetupDetails(state.type);
    })();
  }, []);

  const title = useMemo(() => {
    let msg = "";
    switch (state.type) {
      case "GPA":
        msg = "Setup Group Personal Accident";
        break;
      case "GTL":
        msg = "Setup Group Term Life";
        break;
    }
    return msg;
  }, [state.type]);

  return (
    <section>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav />
          <MainBody>
            <WidthLimiter>
              <PageTitle title={title} />
              <GpaGtlForm type={state.type} details={setupDetails} />
            </WidthLimiter>
          </MainBody>
        </>
      )}
    </section>
  );
};

export default GpaGtlSetup;
